import { render, staticRenderFns } from "./MenuTopCat.vue?vue&type=template&id=2453eefa&scoped=true&"
import script from "./MenuTopCat.vue?vue&type=script&lang=js&"
export * from "./MenuTopCat.vue?vue&type=script&lang=js&"
import style0 from "./MenuTopCat.vue?vue&type=style&index=0&id=2453eefa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453eefa",
  null
  
)

export default component.exports